import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F7] pt-32 pb-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1
            className="text-4xl sm:text-5xl font-light text-[#2C2C2C] mb-8"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Politique de confidentialité — Glow & You
          </h1>
          
          <div className="space-y-8 text-[#2C2C2C]">
            {/* Collecte des données */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Collecte des données
              </h2>
              <p className="leading-relaxed">
                Nous collectons uniquement les informations que vous nous fournissez volontairement via notre formulaire de pré-consultation (nom, courriel, téléphone, ville, préférences de style). Ces informations sont utilisées uniquement pour vous proposer un service personnalisé.
              </p>
            </section>

            {/* Utilisation des données */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Utilisation des données
              </h2>
              <p className="leading-relaxed">
                Vos informations sont utilisées exclusivement par Glow & You pour analyser votre demande et vous contacter. Elles ne sont jamais vendues, partagées ou transmises à des tiers.
              </p>
            </section>

            {/* Photographies et résultats */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Photographies et résultats
              </h2>
              <p className="leading-relaxed">
                Avec votre consentement explicite, Glow & You peut utiliser des photos de votre séance, des résultats avant/après ou des témoignages à des fins promotionnelles sur notre site web et nos réseaux sociaux. Vous pouvez retirer votre consentement à tout moment en nous contactant à{' '}
                <a href="mailto:contact@glowyou.org" className="text-[#8B4513] hover:underline">
                  contact@glowyou.org
                </a>
                . Sans consentement écrit de votre part, aucune photo ou information vous concernant ne sera publiée.
              </p>
            </section>

            {/* Témoignages et avis */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Témoignages et avis
              </h2>
              <p className="leading-relaxed">
                Si vous choisissez de laisser un témoignage ou un avis, vous acceptez qu'il soit publié sur notre site web et nos plateformes. Votre prénom ou initiales pourront être utilisés. Vous pouvez demander le retrait de votre témoignage à tout moment.
              </p>
            </section>

            {/* Conservation des données */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Conservation des données
              </h2>
              <p className="leading-relaxed">
                Vos données sont conservées uniquement le temps nécessaire à votre accompagnement et supprimées sur demande.
              </p>
            </section>

            {/* Vos droits */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Vos droits
              </h2>
              <p className="leading-relaxed">
                Conformément à la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE), à la Loi 25 du Québec et à la législation ontarienne sur la protection de la vie privée (FIPPA), vous avez le droit d'accéder à vos informations, de les corriger ou de demander leur suppression en nous contactant à{' '}
                <a href="mailto:contact@glowyou.org" className="text-[#8B4513] hover:underline">
                  contact@glowyou.org
                </a>
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2
                className="text-2xl font-light text-[#8B4513] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                Contact
              </h2>
              <p className="leading-relaxed">
                Pour toute question relative à vos données personnelles, contactez-nous à{' '}
                <a href="mailto:contact@glowyou.org" className="text-[#8B4513] hover:underline">
                  contact@glowyou.org
                </a>
              </p>
            </section>

            {/* Dernière mise à jour */}
            <section className="pt-8 border-t border-[#D4C4B0]">
              <p className="text-sm text-[#8B7D6B]">
                <strong>Dernière mise à jour :</strong> Avril 2025
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
